import { cn } from '@/styles/utils';
import Image from 'next/image';
import * as React from 'react';

interface CartToggleButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  role?: string;
  'aria-checked'?: boolean | 'mixed' | 'false' | 'true';
}

const CartToggleButton = React.forwardRef<
  HTMLButtonElement,
  CartToggleButtonProps
>(
  (
    {
      checked = false,
      onCheckedChange,
      disabled,
      className,
      role = 'checkbox',
      'aria-checked': ariaChecked,
      ...props
    },
    ref,
  ) => {
    const handleClick = () => {
      if (!disabled && onCheckedChange) {
        onCheckedChange(!checked);
      }
    };

    return (
      <button
        type="button"
        role={role}
        aria-checked={ariaChecked !== undefined ? ariaChecked : checked}
        ref={ref}
        disabled={disabled}
        onClick={handleClick}
        className={cn(
          'flex h-6 w-14 py-0.5 px-1 items-center justify-center gap-0.5 rounded-sm border-0 ring-1 body-14m',
          checked
            ? 'ring-[#475467] bg-[#475467] text-white'
            : 'ring-[#93A0B4] bg-white text-[#323B49]',
          className,
        )}
        {...props}
      >
        <Image
          src={checked ? '/images/minus.svg' : '/images/plus.svg'}
          alt={checked ? 'minus' : 'plus'}
          width={16}
          height={16}
        />
        <span>{checked ? '빼기' : '담기'}</span>
      </button>
    );
  },
);

CartToggleButton.displayName = 'CartToggleButton';

export { CartToggleButton };
